import styled from 'styled-components';

export const LoginSection = styled.div`
    background: #F1FEFF;
    padding: 30px 8px;
    height:100vh;
    display: flex;
    align-items: center;
      @media screen and (max-width:1366px) { 
        height:100%; 
         padding: 50px 8px;
   }
    @media screen and (max-width:1199px) {  
        flex-wrap: wrap;
        height:100vh; 
    } 
    @media screen and (max-width:767px) { 
    .signUp-col{ 
      flex-wrap: wrap-reverse;
      gap: 30px;
        }
    } 
 
      
   
`;
export const LoginLeftPart = styled.div`
   @media screen and (max-width:767px) { 
    border-top: 1px dashed;
    padding-top: 35px;
}
  
`;
export const LoginRightPart = styled.div`

`; 
export const BackToHomeBtn = styled.div`
    margin-bottom: 30px;
   @media screen and (max-width:1366px) { 
        margin-bottom: 20px;
}
    @media screen and (max-width:767px) { 
        margin-top: 20px;
    }
    .back-btn{
        padding: 0;
        background: transparent;
        border: none;
        display: flex;
        align-items: center;
        gap: 5px;
        justify-content: center;
        color: #333333;
        font-family: "Jost", sans-serif;
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
        width: 100%;
       &:active{
        background: transparent;
        border: none;
        color: #333333;
       } 
        img{
            width: 20px;
            height: 100%;
            transform: rotate(90deg);
            margin-top: 1px;
        }
    }
`;
export const GreatNonProfitsImg = styled.div`
    text-align: center;
    margin-bottom: 30px;

    img{
        width: 100%;
    }
`;
export const UserCreateTitle = styled.div`
    text-align: center;
    margin-bottom: 30px;

    &.user-password-reset-title{
        display: none;
    }
`;
export const FormTitle = styled.h2`
    color: #33A7AE;
    font-family: "Jost", sans-serif;
    font-size: 30px;
    font-weight: 800;
    line-height: 43px;
    text-transform: capitalize;
    @media screen and (max-width:991px) {
        font-size: 25px;
        line-height: 35px;
    }

`;
export const LoginForm = styled.div`
    max-width: 340px;
    width: 100%;
    margin: 0 auto;

    .login-form{
        .form-group {
            margin-bottom: 20px;

            &:nth-child(2){
                margin-bottom: 10px;
            }

            .input-group {
                background: #FFFFFF;
                box-shadow: 0px 10px 20px #0000000F;
                border-radius: 8px;

                input {
                    background: transparent;
                    border: none;
                    padding: 14px 12px 14px 20px;
                    color: #333333;
                    font-family: "Jost", sans-serif;
                    font-size: 20px;
                    font-weight: 400;
                    line-height: 20px;
                    border-radius: 8px;
                }
                .input-group-text {
                    background: transparent;
                    border: none;
                }
            }
        }
    }

    &.password-reset-wrapper{
        // display: none;
        max-width: 600px;
        width: 100%;
        box-shadow: 0px 0px 30px #C4E4E6;
        margin: 50px auto 0;
        padding: 30px;
        border-radius: 20px;

        @media screen and (max-width: 991px){
            max-width: 500px;
            border-radius: 15px;
        }

        @media screen and (max-width: 575px){
            padding: 20px;
        }
    }
`;

export const ForgotPasswordBtn = styled.div`
    text-align: right;

    button{
        padding: 0;
        color: #333333;
        font-family: "Jost", sans-serif;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        text-decoration: none;

        &:hover{
            color: #333333;
        }
        &:focus-visible, &:active, &:active:focus-visible, &:focus-visible{
            color: #333333;
            border: none;
            outline: none;
            box-shadow: none !important;
        }
    }
`;
export const FormSubmitBtn = styled.div`
    margin-top: 20px;

    button{
        box-shadow: 0px 3px 20px #0000001A;
        width: 100%;
        padding: 13px;
    }
`;